import { Link } from "react-router-dom";

const menuItems = [
  {
    name: "בריסקט מעושן",
    desc: "עישון ממושך על גריל עצים אמיתי. קרסט שחור מושלם מבחוץ ופנים ורוד ועסיסי - כל פרוסה מגירה נוזלים",
    tag: "מעושן",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/6a8aea70-f994-4340-aa82-90f534a7ffad_WhatsApp-Image-2026-04-09-at-18.36.26-5.jpeg?v=d5a93825884a0e8a092b434872262e96",
  },
  {
    name: "אסאדו מעושן",
    desc: "נתח שלם מעושן לאיטיות, נמס בפה עם ציפוי קרמלי. מוגש לצד צ'ימיצ'ורי ביתי",
    tag: "מעושן",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/92bfd52b-8d61-43fb-91c0-dbfe9f3022b6_WhatsApp-Image-2026-04-09-at-18.36.26-6.jpeg?v=1052ed20500209353a380a7704d5373e",
  },
  {
    name: "ספריבס טלה",
    desc: "צלעות טלה עדינות בעישון על עצי הדר. הבשר רך ועסיסי עם ניחוח מדהים שממלא את האוויר",
    tag: "מעושן",
    img: "https://storage.readdy-site.link/project_files/4eefa65b-2782-47af-a215-9acc18266367/ae436bef-1edf-4248-ad10-c70fa2b8aff2_WhatsApp-Image-2026-04-09-at-18.37.50-4.jpeg?v=7d37deb625639c8099fe24b890ca2466",
  },
];

const MenuPreview = () => {
  return (
    <section className="py-20 bg-[#faf7f2]" dir="rtl">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span
            className="inline-block bg-[#e85d04]/10 text-[#e85d04] px-4 py-1.5 rounded-full text-sm font-semibold mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            מה אנחנו מגישים
          </span>
          <h2
            className="text-[#1a0a00] font-black text-4xl md:text-5xl mb-4"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            התפריט שלנו
          </h2>
          <p
            className="text-[#5a3e2b] text-lg max-w-xl mx-auto"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            נתחים מובחרים מהמעשנה, תוספות שהם חגיגה ואפילו אופציות לצמחונים - אצלנו יש הכל
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {menuItems.map((item) => (
            <div
              key={item.name}
              className="bg-white rounded-2xl overflow-hidden hover:scale-[1.02] transition-transform duration-300 cursor-pointer"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.name}
                  className="w-full h-full object-cover object-top"
                />
                <span
                  className="absolute top-3 right-3 bg-[#e85d04] text-white text-xs font-bold px-3 py-1 rounded-full"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  {item.tag}
                </span>
              </div>
              <div className="p-5">
                <h3
                  className="text-[#1a0a00] font-bold text-xl mb-2"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  {item.name}
                </h3>
                <p
                  className="text-[#7a5c44] text-sm leading-relaxed"
                  style={{ fontFamily: "'Assistant', sans-serif" }}
                >
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/menu"
            className="inline-block bg-[#1a0a00] hover:bg-[#2d1200] text-white px-10 py-4 rounded-full text-base font-bold transition-colors duration-200 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Assistant', sans-serif" }}
          >
            לתפריט המלא ←
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MenuPreview;
